module.exports = __webpack_public_path__ + "media/images/front/premium_lp/bg_wrapper_01-545ce498291716bb5727bfa3fcc5cb0f.jpg";